import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import Loader from '../../components/loader/Loader'
import DataTable from '../../components/data_table/DataTable'
import moment from 'moment'
import { Button } from 'react-bootstrap'
import { DatePicker, ConfigProvider, Space } from 'antd'
import dayjs from 'dayjs'
import Swal from 'sweetalert2'
import { RotateCw } from 'lucide-react';
import { searchIPDetails } from '../../redux/slice/SearchIPDetails'
import { ipReportStatus } from '../../redux/slice/IPReportStatus'
import { videoAnalysis } from '../../redux/slice/VideoAnalytics'

export default function VideoAnalysis() {
    const [loading, setLoading] = useState(false)
    const [fromDate, setFromDate] = useState(null)
    const [bool, setBool] = useState(false)
    const [toDate, setToDate] = useState(null)
    const { state } = useLocation()
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [isRotating, setIsRotating] = useState(false);
    const data = useSelector(state => state?.videoAnalysis?.data?.analytics)
    const createdDate = useSelector(state => state?.videoAnalysis?.data?.createDateYoutube)
    const reportStatus = useSelector(state => state?.ipReportStatus?.data)

    console.log(state)

    useEffect(() => {
        setLoading(true)
        dispatch(videoAnalysis({ video_id: state._id, navigate })).then((res) => list_res(res))
    }, [])

    const list_res = (res) => {
        if (res?.payload?.status == 200) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    useEffect(() => {
        dispatch(ipReportStatus({ type: "video", link_id: state._id, navigate }))
    }, [bool])

    const download_excel = () => {
        const fromParam = fromDate ? moment(fromDate).format('YYYY-MM-DD') : ''
        const toParam = toDate ? moment(toDate).format('YYYY-MM-DD') : ''
        dispatch(searchIPDetails({
            from_date: fromParam,
            to_date: toParam,
            link_id: state._id,
            type: "video",
            report_type: "pending",
            navigate
        })).then((res) => filter_res1(res.payload))
    }

    const filter_res1 = (res) => {
        if (res?.status == 200) {
            setBool(!bool)
            localStorage.setItem('video_report_id', res?.data?.data?.report_id)
        } else {
            setBool(!bool)
        }
    }

    const handleFilter = () => {
        // setLoading(true)
        Swal.fire({
            title: 'Hold on...',
            text: "Download Report !..",
            allowOutsideClick: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            },
        });

        dispatch(searchIPDetails({
            link_id: state._id,
            type: "video",
            report_type: "downloaded",
            report_id: localStorage.getItem('video_report_id'),
            navigate
        })).then((res) => filter_res(res.payload))
    }

    const filter_res = (res) => {
        if (res?.status == 200) {
            setBool(!bool)
            Swal.close();
            window.open(res?.data?.data?.download_url);
            localStorage.removeItem('video_report_id')
            setFromDate(null)
            setToDate(null)
        } else {

            Swal.fire({
                icon: 'error',
                title: 'Download failed',
                text: res?.data?.message || 'Something went wrong',
            });
        }

    }

    const refresh_report = () => {
        setBool(!bool)
        setIsRotating(true);
        setTimeout(() => setIsRotating(false), 500);
    }

    const handleClearFilter = () => {
        setFromDate(null)
        setToDate(null)
    }

    const columnDefs = [
        {
            headerName: 'S.NO',
            valueGetter: 'node.rowIndex + 1',
            filter: 'false',
            suppressMenu: true,
            sortable: true,
            floatingFilter: false,
            // wrapText: true,
            // autoHeight: true,
            // maxWidth: 120
        },

        // {
        //     headerName: 'IP',
        //     field: 'ip',
        //     filter: 'agTextColumnFilter',
        //     suppressMenu: true,
        //     filter: true,
        //     sortable: true,
        //     floatingFilter: false,
        //     // wrapText: true,
        //     // autoHeight: true,
        // },
        {
            headerName: 'DATE/TIME',
            field: 'added_date',
            cellRenderer: params => {
                if (!params?.value) return '';
                const formattedDate = moment(params.value).format('DD-MMM-YYYY hh:mm A');
                return <span>{formattedDate}</span>;
            },
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: false,
            // wrapText: true,
            // autoHeight: true,
        },



    ]
    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className='layout'>
                            <div className='d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3'>
                                <div>
                                    <h5>Content Analytics</h5>
                                </div>
                                {reportStatus?.length ?
                                    <div>
                                        {reportStatus?.[0]?.report_status === "processing" || reportStatus?.[0]?.report_status === "pending" ?
                                            <div className="d-flex gap-2">
                                                <Button size='sm' className='btn btn-info'>
                                                    Report In Proccessing...
                                                </Button>
                                                <Button size='sm' className='btn btn-secondary' onClick={refresh_report}>
                                                    <RotateCw size={20} className='mb-0' style={{
                                                        transition: 'transform 0.5s ease',
                                                        transform: isRotating ? 'rotate(360deg)' : ''
                                                    }} />
                                                </Button>
                                            </div>
                                            :
                                            reportStatus?.[0]?.report_status === "completed" ? <Button onClick={handleFilter} size='sm' className='btn btn-primary'>
                                                Download Report
                                            </Button> : ''
                                        }
                                    </div> :
                                    <div>
                                        <ConfigProvider
                                            theme={{
                                                components: {
                                                    DatePicker: {
                                                        borderColor: 'hsl(0, 0%, 80%)',
                                                        activeBorderColor: '#33372c',
                                                        activeOutlineColor: 'none',
                                                        hoverBorderColor: 'none',
                                                        activeShadow: 'none',
                                                        zIndexPopup: '99999',
                                                    },
                                                },
                                                token: {
                                                    colorBorder: '#ccc',
                                                    fontFamily: 'Lexend Deca'
                                                },
                                            }}
                                        >
                                            <div className='d-flex flex-wrap gap-2 align-items-center'>
                                                <DatePicker
                                                    placeholder="From Date"
                                                    format="DD/MM/YYYY"
                                                    value={fromDate ? dayjs(fromDate) : null}
                                                    onChange={(date) => setFromDate(date ? date.toDate() : null)}
                                                    style={{ width: 140 }}
                                                    allowClear
                                                    disabledDate={(current) => (current && current > dayjs().endOf('day')) || (current && current < dayjs().subtract(999, 'days').startOf('day')) || (createdDate && current && current < dayjs(createdDate).startOf('day'))}
                                                />
                                                <span className='fw-bold'>-</span>
                                                <DatePicker
                                                    placeholder="To Date"
                                                    format="DD/MM/YYYY"
                                                    value={toDate ? dayjs(toDate) : null}
                                                    onChange={(date) => setToDate(date ? date.toDate() : null)}
                                                    style={{ width: 140 }}
                                                    allowClear
                                                    disabledDate={(current) => (fromDate && current && current < dayjs(fromDate).startOf('day')) || (current && current > dayjs().endOf('day')) || (fromDate && current && current > dayjs(fromDate).add(3, 'months'))}
                                                />

                                                <Button disabled={fromDate && toDate ? false : true} onClick={download_excel} size='sm' className='btn btn-primary'>
                                                    Prepare  Report
                                                </Button>
                                                {(fromDate || toDate) && (
                                                    <Button onClick={handleClearFilter} size='sm' className='btn btn-secondary'>
                                                        Clear
                                                    </Button>
                                                )}
                                            </div>
                                        </ConfigProvider>

                                    </div>}
                            </div>
                            <h6 className='text-primary'>{state?.url}</h6>

                        </div>
                    </div>

                    <div className="col-md-12 mt-2">
                        {loading ?
                            <diV className='d-flex justify-content-center mt-5 pt-5'>
                                <Loader />
                            </diV> :
                            data && data.length ?
                                <DataTable
                                    rowData={data}
                                    columnDefs={columnDefs}
                                    height={'70vh'}
                                    search={false}
                                    excelFileName={'Link Analysis'}
                                />
                                :
                                <div className='empty_section text-center'>
                                    <span>DATA NOT FOUND</span>
                                </div>
                        }
                    </div>
                </div>
            </div >

        </>
    )
}
